import React, { useState } from 'react';
import { SVGPureIcon } from '@ui/svg-icon';
import userStore from '@src/store/user';
import client from '@/store/client';
import appLogger from '@public/log/monitor';

const MenuList = ({}) => {
  const [standalone, setStandalone] = useState(false)

  // fromside=web（网页）/ weishi（卫士）/ client（独立版）/ llq（浏览器）
  if(client.isClient) {
    client.run("GetSystemInfo", ({standalone}) => {
      if(standalone == 1) {
        // 老版本api有bug，需要排除
        if(!client.versionLt("14.0.0.1201")) {
          setStandalone(true)
        }
      }
    })
  }
  const logoutClient = () => {
    client.run("LogOut")
  }
  return (client.isClient || client.isLLQ) && !standalone
    ? null
    : (
      <div className="mx-8px mt-16px">
        <div
          className="flex items-center px-20px h-48px text-primary rounded-8px cursor-pointer hover:font-bold hover:bg-[var(--bg-dropdown-hover)]"
          onClick={evt => {
            if(standalone) {
              userStore.logout({cb: logoutClient});
              return
            }
            userStore.logout();
          }}
        >
          <SVGPureIcon name="logout" className="size-20px !text-primary" />
          <span className="text-14px ml-8px">退出登录</span>
        </div>
      </div>
    )
};
export default MenuList;
